import { FaWhatsapp, FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import React from 'react';
import '../styles/contact.css';

const Contact = () => {

  const contactInfo = [
    {
      icon: <FaPhone className="contact-icon contact-icon-blue" />,
      title: 'Phone',
      value: '+254 721 858828',
      link: 'tel:+254721858828'
    },
    {
      icon: <FaWhatsapp className="contact-icon contact-icon-green" />,
      title: 'WhatsApp',
      value: '+254 721 858828',
      link: 'https://wa.me/254721858828'
    },
    {
      icon: <FaEnvelope className="contact-icon contact-icon-red" />,
      title: 'Email',
      value: 'jayjikos@gmail.com',
      link: 'mailto:jayjikos@gmail.com'
    },
    {
      icon: <FaMapMarkerAlt className="contact-icon contact-icon-yellow" />,
      title: 'Location',
      value: `RUIRU 
      (Off Ruiru-Kiambu road, opp. Valleyland Millers`,
      link: 'https://maps.google.com/?q=Ruiru-Kiambu road, opp. Valleyland Millers'
    },
    {
      icon: <FaClock className="contact-icon contact-icon-purple" />,
      title: 'Working Hours',
      value: 'Mon - Fri: 8:00 AM - 5:00 PM',
      link: null
    }
  ];
  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-container">
          <h1 className="contact-hero-title">Contact Us</h1>
          <p className="contact-hero-subtitle">
            We'd love to hear from you. Get in touch with us today!
          </p>
        </div>
      </section>

      {/* Contact Info & Form */}
      <section className="contact-main">
        <div className="contact-container">
          <div className="contact-layout">
            {/* Contact Information */}
            <div className="contact-info">
              <h2 className="contact-section-title">Get in Touch</h2>
              <p className="contact-section-description">
                Have questions about our products or services? Reach out to us using the contact information below or send us a message.
              </p>
              
              <div className="contact-info-grid">
                {contactInfo.map((item, index) => (
                  <div key={index} className="contact-info-item">
                    <div className="contact-info-icon">
                      {item.icon}
                    </div>
                    <div className="contact-info-content">
                      <h3 className="contact-info-title">{item.title}</h3>
                      {item.link ? (
                        <a 
                          href={item.link} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="contact-info-link"
                        >
                          {item.value}
                        </a>
                      ) : (
                        <p className="contact-info-text">{item.value}</p>
                      )}
                      {item.subValue && (
                        <p className="contact-info-text">{item.subValue}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>

            </div>

            {/* WhatsApp Direct Chat */}
            <div className="whatsapp-card">
              <div className="whatsapp-header">
                <div className="whatsapp-icon-container">
                  <FaWhatsapp className="whatsapp-icon-large" />
                </div>
                <h2 className="whatsapp-title">Chat with Us on WhatsApp</h2>
                <p className="whatsapp-subtitle">Our team is ready to answer your questions</p>
              </div>
              
              <div className="whatsapp-button-container">
                <a
                  href="https://wa.me/254721858828"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-button"
                >
                  <FaWhatsapp className="whatsapp-button-icon" /> Open WhatsApp Chat
                </a>
                <p className="whatsapp-response-time">Typically replies within an hour</p>
              </div>

              <div className="faq-section">
                <h3 className="faq-title">Frequently Asked Questions</h3>
                <div className="faq-list">
                  <div className="faq-item">
                    <h4 className="faq-question">What are your working hours?</h4>
                    <p className="faq-answer">We're available Monday to Friday from 8:00 AM to 5:00 PM</p>
                  </div>
                  <div className="faq-item">
                    <h4 className="faq-question">Do you offer emergency services?</h4>
                    <p className="faq-answer">Yes, we provide 24/7 emergency services for urgent repairs and support.</p>
                  </div>
                  <div className="faq-item">
                    <h4 className="faq-question">What areas do you serve?</h4>
                    <p className="faq-answer">We serve the entire Nairobi region and its environs. Our supplies are done within the country.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <div className="map-container">
          <h2 className="map-title">Our Location</h2>
          <div className="map-wrapper">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.015255606467!2d36.9468735734998!3d-1.1495917354889227!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f38abe267d67b%3A0x1fe1faa2ba97c6bd!2sVALLEYLAND%20MILLERS!5e0!3m2!1sen!2ske!4v1763232078913!5m2!1sen!2ske"
              className="map-iframe"
              allowFullScreen=""
              loading="lazy"
              title="Our Location"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
